export default __webpack_public_path__ + "static/media/person-check.231b8a7b.svg";